// Registry of currently faked endpoints. Dev-only: this file imports from
// features by design, so mock data lives next to the feature that owns it
// and is deleted with it.

// import { billingTokenHandlers } from "../../features/billing/internal/internal-overview/data-access/mocks/billing-token.handlers.mock";
// import { internalTransactionHandlers } from "../../features/billing/internal/internal-overview/data-access/mocks/ib-transactions.handlers.mock";
// import { invoiceHandlers } from "../../features/billing/internal/internal-overview/data-access/mocks/invoice.handlers.mock";
// import { onboardingHandlers, paymentMethodHandlers } from "../../features/billing/internal/internal-overview/data-access/mocks/onboarding.handlers.mock";
// import { chardiWeightingHandlers } from "../../features/connectors/components/connector.chardi/chardi.weighting/data-access/mocks/chardi-weighting.handlers.mock";
// import { smartCarHandlers } from "../../features/smart-cars/mocks/smart-car.handlers.mock";
import { MockHandler } from "./mock.type";


export const mockHandlers: MockHandler[] = [
  // ...onboardingHandlers,
  // ...paymentMethodHandlers,
  // ...invoiceHandlers,
  // ...billingTokenHandlers,
  // ...internalTransactionHandlers,
  // ...chardiWeightingHandlers,
  // ...internalTransactionHandlers
  // ...smartCarHandlers
];